module.exports = __webpack_public_path__ + "img/qrcode.9047fe70.png";